import gsap from "gsap";

document.addEventListener("DOMContentLoaded", () => {
  if (!document.querySelector("body").classList.contains("single-location")) {
    return;
  }

  const circles = document.querySelector(".circles .circle");
  const circleUps = gsap.utils.toArray(".circles .circle-up");
  const circleDowns = gsap.utils.toArray(".circles .circle-down");
  gsap.to(circleUps, {
    yPercent: -50,
    scrollTrigger: {
      trigger: ".circles",
      start: "top top",
      end: "bottom bottom",
      scrub: 2,

    },
  });
  gsap.to(circleDowns, {
    yPercent: 50,
    scrollTrigger: {
      trigger: ".circles",
      start: "top top",
      end: "bottom bottom",
      scrub: 2,
    },
  });
});
